import type { WidgetSettings } from '@teo/widget-shared';

export type WidgetModuleId =
  | 'chat'
  | 'richMedia'
  | 'voiceMessages'
  | 'fileUpload'
  | 'contextPopup'
  | 'exitIntent'
  | 'humanGate';

export type ModuleRegistry = {
  isEnabled: (moduleId: WidgetModuleId) => boolean;
  listEnabled: () => WidgetModuleId[];
};

/**
 * Feature flags derived from parsed settings.
 * Extend as backend exposes per-module toggles.
 * voiceMessages — false until phase 4 (deferred).
 * humanGate — soft bot filter; always on in MVP (kill via data-human-gate="false").
 */
export function createModuleRegistry(settings: WidgetSettings): ModuleRegistry {
  const flags: Record<WidgetModuleId, boolean> = {
    chat: true,
    richMedia: true,
    voiceMessages: false,
    fileUpload: true,
    contextPopup: settings.content.proactiveGreetingEnabled,
    exitIntent: settings.content.proactiveGreetingEnabled,
    humanGate: true,
  };

  return {
    isEnabled: (moduleId) => flags[moduleId] ?? false,
    listEnabled: () =>
      (Object.keys(flags) as WidgetModuleId[]).filter((id) => flags[id]),
  };
}
